import { render } from "./ComparePage.vue?vue&type=template&id=a4887f0e&scoped=true"
import script from "./ComparePage.vue?vue&type=script&lang=js"
export * from "./ComparePage.vue?vue&type=script&lang=js"

import "./ComparePage.vue?vue&type=style&index=0&id=a4887f0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4887f0e"]])

export default __exports__